export default "__VITE_ASSET__DoeO12HI__"